import { MARKETING_PARAM_KEYS } from '@shared/marketing'
import { markCarriedFbclid } from '@shared/marketing/click-provenance'
import { getCookie } from '@shared/utils'

/**
 * 마케팅 파라미터를 URL에 보존하는 유틸리티 함수
 * 현재 URL 또는 쿠키에서 마케팅 파라미터를 가져와 대상 URL에 추가
 */
export const preserveMarketingParams = (targetUrl: URL): URL => {
  MARKETING_PARAM_KEYS.forEach((param) => {
    // 1. 현재 URL에서 확인
    const urlValue = new URL(window.location.href).searchParams.get(param)
    if (urlValue) {
      targetUrl.searchParams.set(param, urlValue)
    } else {
      // 2. 쿠키에서 확인
      const cookieValue = getCookie(param)
      if (cookieValue) {
        targetUrl.searchParams.set(param, cookieValue)
      }
    }
  })

  return markCarriedFbclid(targetUrl)
}
